import { Button } from '@mui/material';

export const ButtonGustio = ({
  children,
  onClick,
  variant = 'contained',
  color = 'primary',
  startIcon,
  endIcon,
  size = 'medium',
  fullWidth = true,
  disabled = false,
  sx = {},
  ...rest
}) => {
  return (
    <Button
      onClick={onClick}
      variant={variant}
      color={color}
      startIcon={startIcon}
      endIcon={endIcon}
      size={size}
      fullWidth={fullWidth}
      disabled={disabled}
      sx={{ fontSize: 15, fontFamily: '"Roboto", sans-serif', textTransform: "none", fontWeight: "600 !important", paddingTop: 1.4, paddingBottom: 1.4, borderRadius: 2, boxShadow: "none !important" }}
      {...rest}
    >
      {children}
    </Button>
  );
};
